<template>
  <div class="chargingTime">
    <title1
      type="1"
      title="充电时间尖峰平谷占比"
      subTitle="Electric Port Overview"
    />
    <div ref="pieone" id="pieon" class="pieon"></div>
  </div>
</template>
 
<script>
import * as echarts from "echarts";
import { onMounted, ref } from "vue";
import title1 from "@/views/exposition/components/title1";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1,
  },
  data() {
    return {
      chart: null,
      target: [],
    };
  },
  destroyed() {
    this.$bus.$off('bigScreen::storedEnergyId')
  },
  mounted() {
    this.$bus.$on("bigScreen::storedEnergyId", () => {
      this.chargingTime()
    })
    this.chargingTime()
  },
  methods: {
    // 创建图表
    createChartHandler() {
		console.log(this.target, '222222222222222')
		
      this.chart = echarts.init(document.getElementById("pieon"));
      this.chart.setOption(this.getChartOption(this.target));
      window.addEventListener("resize", () => {
        setTimeout(() => {
          this.chart.resize();
        });
      });
    },
    chargingTime() {
      let params = {
        enCode: "chuneng-quanguo-j7tcdsjjfpgzb",
        "@energyId": localStorage.getItem('bigScreen::storedEnergyId') || "ES00001",
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "chargingTime");
          let data1 = res[0] || {};
          this.target.push(data1.f_charge_duration || 1);
          this.target.push(data1.g_charge_duration || 2);
          this.target.push(data1.j_charge_duration || 3);
          this.target.push(data1.p_charge_duration || 4);
          this.createChartHandler();
        })
        .catch((err) => {
          console.log(err);
        });
      return this.target;
    },
    getChartOption(data1) {
      // console.log(JSON.parse(JSON.stringify(data1)), "data1");
      const pieone = ref(null);
      const data = [
        { value: data1[0], name: "尖" },
        { value: data1[1], name: "峰" },
        { value: data1[2], name: "平" },
        { value: data1[3], name: "谷" },
      ];
      // console.log('data:',data)
      this.chart.setOption({
        // 图例设置
        legend: {
          orient: "vertical",
          top: "30%",
          right: "0%",
          itemWidth: 12,
          itemHeight: 8,
          // itemGap: 25,
          formatter: function (name) {
            //通过name获取到数组对象中的单个对象
            // let singleData = data.filter(function (item) {
            //   return item.device_type == device_type;
            // });
            // let nameValue = singleData[0].alerm_num;
            // return [`{num|${name}}` + `{name|${nameValue}h}`];
          },
          textStyle: {
            color: ["#FFD15C", "#31C6C9", "#FFFFFF", "#20E6A4"],
            fontSize: 18,
            rich: {
              name: {
                fontSize: 18,
                fontFamily: "HT",
                // color: "#ffaa00",
                padding: [0, 0, 0,20], //上，右，下，左
              },
              num: {
                fontSize: 18,
                padding: [0, 0, 0, 0], //上，右，下，左
                // padding: [10, 10],
              },
            },
          },
        },
        // 系列数据设置
        series: [
          {
            name: "Nightingale Chart", // 系列名称
            type: "pie", // 图表类型为饼图
            radius: [20, 150], // 饼图的内外半径
            center: ["40%", "50%"], // 饼图的中心位置
            roseType: "area", // 玫瑰图类型为区域玫瑰图
            itemStyle: {
              borderRadius: 4,
              // 数据项的样式设置
              normal: {
                //取消指示提示文字
                label: {
                  "formatter": '{b}: {d}%',
                  // formatter: function (name) {
                  //   //通过name获取到数组对象中的单个对象
                  //   let singleData1 = data.filter(function (item) {
                  //     return item.name == name;
                  //   });
                  //   let nameValue1 = singleData1[0].value;
                  //   return [`${name}` + `${nameValue1}%`];
                  // },
                  show: true,
                  fontSize: 24,
                  fontFamily: "HT",
                },
                // 取消指示提示线
                labelLine: {
                  show: true,
                },
              },
            },
            color: ["#FFD15C", "#31C6C9", "#FFFFFF", "#20E6A4"],
            // 数据
            data: data,
          },
        ],
      });

      return { pieone };
    },
  },
};
</script>
 
<style scoped>
@font-face {
  font-family: "HT";
  src: url("~@/assets/font/HT.ttf");
}
#pieon {
  width: 565 px;
  height: 400px;
  /* z-index: 10000; */
}
</style>